import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  EnrollVoiceprintPayload,
  Voiceprint,
  voiceprintApi,
} from '@/services/voiceprintApi';

export const voiceprintKeys = {
  all: ['voiceprints'] as const,
  mine: () => [...voiceprintKeys.all, 'mine'] as const,
  activeForSession: (role: string) =>
    [...voiceprintKeys.all, 'active-for-session', role] as const,
};

export function useMyVoiceprints() {
  return useQuery<Voiceprint[]>({
    queryKey: voiceprintKeys.mine(),
    queryFn: () => voiceprintApi.listMine(),
    staleTime: 60_000,
  });
}

export function useEnrollVoiceprint() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: EnrollVoiceprintPayload) => voiceprintApi.enroll(payload),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: voiceprintKeys.all });
    },
  });
}

export function useRevokeVoiceprint() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => voiceprintApi.revoke(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: voiceprintKeys.all });
    },
  });
}
